<template>
  <div class="header">
    <el-button class="print-button" @click="print()">
      Imprimir
    </el-button>
    <div class="back-wrapper">
      <Func4BackButton @click.native="back()" />
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Func4BackButton from '@/views/4/BackButton'

export default {
  name: 'Func4PrintHeader',
  components: { Func4BackButton },
  methods: {
    ...mapActions('RedeCredenciada', ['setViewPrint']),
    back () {
      this.setViewPrint(false)
    },
    print () {
      window.print()
    }
  }
}
</script>

<style scoped lang="less">

.header {
  display: flex;
  place-content: center;
  position: relative;
  padding: 27px 0;

  @media print {
    display: none;
  }
}

.back-wrapper {
  display: flex;
  position: absolute;
  height: 100%;
  top: 0;
  right: 0;
}

.print-button {
  width: 180px;
  background-color: var(--cor-primaria-aplicacao);
  color: white;
}

</style>
